import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ModulesEnum } from '@api/ringil-api.v2';
import { Dialog } from 'primereact/dialog';
import ComponentSvg from '@icons/ComponentSvg.tsx';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage.tsx';
import SvgGrayInfo from '@components/ringil3/icons/GrayInfo.tsx';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import { VerticalFieldAndValueWithIcon } from '@components/ringil3/Containers/VerticalFieldAndValueWithIcon.tsx';

interface ComponentProps {
  modules?: ModulesEnum[];
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const ConfirmCodeRefreshDialog: React.FC<ComponentProps> = ({ modules, visible, onHide, onConfirm }) => {
  const { tr } = useTranslationLgs();


  return (
    <>
      {/* @ts-ignore*/}
      <Dialog
        visible={visible}
        onHide={onHide}
        style={{ width: '450px' }}
        header={tr('ConfirmCodeRefreshDialog.title', 'Generate new code')}
      >

        <div>
          <div className="mb-6">
            <VerticalFieldAndValueWithIcon
              label={tr('ConfirmCodeRefreshDialog.subtitle', 'For modules')}
              valueText={modules?.join(', ')}
              icon={<ComponentSvg />}
            />
          </div>

          <div className="mb-6">
            <COInlineMessage variant={'warning'} icon={<SvgGrayInfo />}>
              {tr('ConfirmCodeRefreshDialog.warning', 'Warning: Generating a new code will invalidate the current code. All users will need to use the new code.')}
            </COInlineMessage>
          </div>

          <div className="mb-6">
            <RingilButton
              label={tr('ConfirmCodeRefreshDialog.confirm', 'Generate New Code')}
              onClick={onConfirm}
              mode={'filled'}
            />
            <RingilButton
              label={tr('ConfirmCodeRefreshDialog.cancel', 'Cancel')}
              onClick={onHide}
              mode={'text-only'}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ConfirmCodeRefreshDialog;
